import { render, staticRenderFns } from "./hearts.vue?vue&type=template&id=62dbf29d&"
import script from "./hearts.vue?vue&type=script&lang=js&"
export * from "./hearts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62dbf29d')) {
      api.createRecord('62dbf29d', component.options)
    } else {
      api.reload('62dbf29d', component.options)
    }
    module.hot.accept("./hearts.vue?vue&type=template&id=62dbf29d&", function () {
      api.rerender('62dbf29d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/hearts.vue"
export default component.exports